import { Fragment } from 'react';
import { stopDots, type EnRouteRow } from './enRouteModel';

/**
 * One dot per stop, the done ones first; a link before each dot takes that
 * dot's state. With many stops the links collapse first, then the dots shrink.
 */
export function StopDots({ row }: { row: EnRouteRow }) {
  return (
    <span
      aria-hidden="true"
      data-testid="dispatch-stop-dots"
      className="flex min-w-0 items-center overflow-hidden"
    >
      {stopDots(row).map((dot, i) => (
        <Fragment key={i}>
          {i > 0 && (
            <span className={`h-[3px] flex-1 ${dot === 'done' ? 'bg-route' : 'bg-border'}`} />
          )}
          <span
            data-dot={dot}
            className={`aspect-square w-2.5 min-w-1 shrink rounded-full border-2 ${
              dot === 'done' ? 'border-route bg-route' : 'border-border bg-transparent'
            }`}
          />
        </Fragment>
      ))}
    </span>
  );
}
